import logo from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import headerGame from '../Assets/Imgs/Header-Images-Game-1.png';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';

function CheckoutFailure() {
  return (
    <div className="App">
      <NavBar />
      <div className="App-header story-header headerGrowing">
        <img src={headerGame} className="header-img headerBGMoving" alt="header" />
        <div className="story-bg info-bg gameHeaderShade">
          <div className="blockWhite" style={{padding:'3%'}}>
            <img src={logo} className="logoInText" />
            <p>
            Your transaction has been canceled or failed to process.<br/>
            If you need help, please feel free to contact ah@sied.online<br/>
            <br/>
            We apologize for any inconvenience
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CheckoutFailure;
